import {
  MapPin,
  Heart,
  Star,
  Home,
  Coffee,
  ShoppingBag,
  Camera,
  Utensils,
  Music,
  Book,
  Plane,
  Car,
  Bike,
  Building,
  Gift,
  type LucideIcon,
} from 'lucide-react';

export const AVAILABLE_ICONS: Record<string, LucideIcon> = {
  MapPin,
  Heart,
  Star,
  Home,
  Coffee,
  ShoppingBag,
  Camera,
  Utensils,
  Music,
  Book,
  Plane,
  Car,
  Bike,
  Building,
  Gift,
};

export const ICON_NAMES = Object.keys(AVAILABLE_ICONS);

